module.exports = __webpack_public_path__ + "img/symbol-45-left.0ac0831d.png";